import React from 'react';
import styled from 'styled-components';
import { colors } from '../../styles';

const TextArea = (props) => (
  <StyledTextArea {...props} />
);

const StyledTextArea = styled.textarea`
  width: 100%;
  padding: 12px;
  border: 1px solid ${colors.border};
  border-radius: 8px;
  font-family: 'Indie Flower', cursive;
  font-size: 1rem;
  resize: vertical;
  min-height: 100px;
  
  &:hover, &:focus {
    outline: none;
    border-color: ${colors.secondary};
  }
`;

export default TextArea; 